import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";

export default class ArTaxService extends ApiService {
  namespace = "tax";
  icon = "PercentSign";
  name = "tax";
  favicon = "Bank";
  window = 290;
  Width = 690;
  DOMAIN = DOMAIN.TAX;
  singular = this.terminology.tax.singular;
  plural = this.terminology.tax.plural;
  vowel = this.terminology.tax.vowel;
  action = "action";
  sidebarControls = [
    { type: 'checkbox', name: 'status', label: 'Inactivate', trueValue: 0, falseValue: 1, editOnly: true },
  ];
  constructor() {
    super("ar-taxes");
  }
}
